/**
 * useDeliveryAddresses
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import DeliveryAddressesContext from './delivery-addresses-context'

const useDeliveryAddresses = () => {
  const context = useContext(DeliveryAddressesContext)
  return context
}

export default useDeliveryAddresses
